import axios from 'axios';

// state
const state = {
  dataMasuk: [],
};
// action
const actions = {
  async getPengeluaran({ commit }, param) {
    try {
      const res = await axios.post(`${this.state.API_URL}/read_pengeluaran.php`, param);
      // console.log('data',res.data.data);
      commit('setPengeluaran', res.data);
    } catch (error) {
      console.error(error);
    }
  },
  async editPengeluaran({ commit }, param) {
    try {
      const res = await axios.post(`${this.state.API_URL}/edit_pengeluaran.php`, param);
      return res.data;
    } catch (error) {
      console.error(error);
    }

  },

  async deletePengeluaran({ commit }, param) {
    try {
      const res = await axios.post(`${this.state.API_URL}/delete_pengeluaran.php`, param);
      return res.data;
    } catch (error) {
      console.error(error);
    }

  },
  async addPengeluaran({ commit }, param) {
    try {
      const res = await axios.post(`${this.state.API_URL}/add_pengeluaran.php`, param);
      return res.data;
    } catch (error) {
      console.error(error);
    }

  },

   
   
  
};
const mutations = {
  setPengeluaran(state, data) {
    state.dataMasuk = data.data;
    //  console.log('data di pemasukan',state.dataMasuk);
  },
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  state,
};
